import { useRef } from "react";
import { SearchInput } from "../SearchInput";
import { SearchPopup } from "../SearchPopup";
import { useOutsideClick } from "./hooks/useOutsideClick";
import { useGlobalSearch } from "./hooks/useGlobalSearch";
import "./GlobalSearch.scss";

export const GlobalSearch = () => {
  const globalSearchRef = useRef<HTMLDivElement>(null);
  const {
    searchValue,
    isSearchBarOpen,
    inputRef,
    onSetSearchValue,
  } = useGlobalSearch();

  useOutsideClick({ ref: globalSearchRef });

  return (
    <div className="globalSearch" ref={globalSearchRef}>
      <SearchInput
        searchValue={searchValue}
        onSetSearchValue={onSetSearchValue}
        inputRef={inputRef}
      />
      {isSearchBarOpen && <SearchPopup searchValue={searchValue} />}
    </div>
  );
};
